const header = [
	{
		'name': "Product",
		'id': 0,
		'isActive': false
	},
	{
		'name': "Details",
		'id': 1,
		'isActive': false
	},
	{
		'name': "Reviews",
		'id': 2,
		'isActive': false
	}
];

const evaluation = [
	{
		'name': 'All Feedback',
		'id': 1,
		'isActive': false,
		'value': 'total',
		'grade': 0
	},
	{
		'name': 'Positive',
		'id': 2,
		'isActive': false,
		'value': 'good',
		'grade': 1
	},
	{
		'name': 'Neutral',
		'id': 3,
		'isActive': false,
		'value': 'medium',
		'grade': 2
	},
	{
		'name': 'Negative',
		'id': 4,
		'isActive': false,
		'value': 'bad',
		'grade': 3
	}
];
export {
	header,
	evaluation
}
